import { Record } from 'immutable';
export interface ResetPasswordInterface {
  isResettingPassword: boolean;
  isPasswordReset: boolean;
  resetPasswordFailure: boolean;
}

/**
 * Properties to determine password reset process state
 */
export const initialState: ResetPasswordInterface = {
  isResettingPassword: false,
  isPasswordReset: false,
  resetPasswordFailure: false
};

export default class ResetPasswordState extends Record(initialState) {
}
